var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSheetsIcon = function SvgSheetsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.746674V15.2467H16V0.746674H0ZM7 13.2467H2V10.7467H7V13.2467ZM7 9.24667H2V6.74667H7V9.24667ZM7 5.24667H2V2.74667H7V5.24667ZM14 13.2467H9V10.7467H14V13.2467ZM14 9.24667H9V6.74667H14V9.24667ZM14 5.24667H9V2.74667H14V5.24667Z",
    fill: "#1FA363"
  })));
};
export { SvgSheetsIcon as ReactComponent };
export default __webpack_public_path__ + "sheets-icon.svg";